// Server-stamped semantic category on notification rows.
enum MmcNotificationCategory {
  COACHING_NOTE = "coaching-note",
  COACHING_TASK = "coaching-task",
}

export default MmcNotificationCategory;
